(function () {
    'use strict';

    function activityConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/activityConfiguration.html',
            link: function (scope) {
            }
        };
    }

    activityConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('activityConfiguration', activityConfiguration);
})();
